// extracted by mini-css-extract-plugin
module.exports = {"Role":"Role_Role__2M5k-","Role_portfolio":"Role_Role_portfolio__C1AAF","Role__Letters":"Role_Role__Letters__2JsbS","Role__Letters_portfolio":"Role_Role__Letters_portfolio__3Ui_o"};